import React, { Fragment, Suspense, lazy } from "react";
import { MuiThemeProvider, CssBaseline } from "@material-ui/core";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import theme from "./theme";
import GlobalStyles from "./GlobalStyles";
import * as serviceWorker from "./serviceWorker";
import Pace from "./shared/components/Pace";
//import Gold from './logged_out/components/erpsuite/gold'
//import Bronze from './logged_out/components/erpsuite/bronze'
//import Silver from './logged_out/components/erpsuite/silver'

const LoggedOutComponent = lazy(() => import("./logged_out/components/Main"));

function App() {
  return (
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        <Pace color={theme.palette.primary.light} />
        <Suspense fallback={<Fragment />}>
          <Switch>
            <Route path="/c">
            </Route>
            {/* <Route path="/erpsuite-gold">
              <Gold />
            </Route>
            <Route path="/erpsuite-bronze">
              <Bronze />
            </Route>            
            <Route path="/erpsuite-Silver">
              <Silver />
            </Route> */}
            <Route path="/">
              <LoggedOutComponent />
            </Route>            
          </Switch>
        </Suspense>
      </MuiThemeProvider>
    </BrowserRouter>
  );
}

serviceWorker.register();

export default App;



// WEBPACK FOOTER //
// ./src/App.js